// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"ce1a60fb","724":"2576daba","909":"b0501038"}[chunkId] + ".chunk.css";
};